import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import t from '../../lib/I18n';

import PassengerRailcard from '../../records/PassengerRailcard';

import BinWithCrossIcon from '../icons/BinWithCrossIcon';
import StepperInput from '../form/StepperInput';
import RailcardTypes from './RailcardTypes';
import PureRenderComponent from '../PureRenderComponent';

class Railcard extends PureRenderComponent {

    static propTypes = {
        code: PropTypes.string,
        quantity: PropTypes.number,
        enableRemoving: PropTypes.bool,
        onChange: PropTypes.func,
        onDelete: PropTypes.func,
        error: PropTypes.string
    };

    static defaultProps = {
        code: '',
        quantity: 0,
        enableRemoving: false,
        onChange: _.noop,
        onDelete: _.noop,
        error: ''
    };

    _onRailcardChange = (railcard = {}) => {
        const code = railcard.code;
        const quantity = this.props.quantity;
        const passengerRailcard = new PassengerRailcard({ code, quantity });
        this.props.onChange(passengerRailcard);
    };

    _onQuantityChange = (quantity) => {
        const code = this.props.code;
        const passengerRailcard = new PassengerRailcard({ code, quantity });
        this.props.onChange(passengerRailcard);
    };

    render () {
        const { enableRemoving, error, onDelete } = this.props;
        return (
            <li className="railcards__item">
                <StepperInput
                    name="clearfix"
                    value={ this.props.quantity }
                    min={ 1 }
                    max={ 9 }
                    onChange={ this._onQuantityChange }
                    error={ error }
                />

                <RailcardTypes
                    value={ this.props.code }
                    onChange={ this._onRailcardChange }
                    error={ error }
                />

                { enableRemoving && <span className="railcards__item__remove" onClick={ onDelete }>
                    <span className="sr-only">{ t('railcard.list.remove') }</span>
                    <BinWithCrossIcon />
                </span> }
            </li>
        );
    }
}

export default Railcard;



// WEBPACK FOOTER //
// ./src/components/search/Railcard.js